module.exports = __webpack_public_path__ + "static/flags/SE-1140f871292a4c0e110d446d30d01891.gif";